import {
	faCartShopping,
	faChevronRight,
	faMagnifyingGlass,
	faUser,
} from "@fortawesome/pro-solid-svg-icons";
import { PlaceholderCard } from "@/components/landing/shared";
import { Icon } from "@/components/ui/Icon";

const COPY = {
	en: { featured: "Featured products", viewAll: "View all" },
	ar: { featured: "منتجات مميزة", viewAll: "عرض الكل" },
};

interface HeroStorePlaceholderProps {
	locale: string;
}

/** Skeleton storefront shown inside the browser window when no hero image is set. */
function HeroStorePlaceholder(prop: HeroStorePlaceholderProps) {
	const { locale } = prop;
	const t = locale === "ar" ? COPY.ar : COPY.en;

	return (
		<div style={{ background: "#fefdfb" }}>
			{/* Store nav */}
			<div className="flex items-center justify-between gap-3 px-5 pb-3 pt-4">
				<PlaceholderCard className="h-3 w-16 rounded-full" />
				<div className="hidden items-center gap-4 lg:flex">
					{[10, 9, 11, 8].map((w, i) => (
						<PlaceholderCard
							key={i}
							className="h-2.5 rounded-full"
							style={{
								width: `${w * 0.25}rem`,
								animationDelay: `${i * 0.15}s`,
							}}
						/>
					))}
				</div>
				<div className="flex items-center gap-3 text-[#9ca3af]">
					<Icon icon={faMagnifyingGlass} className="h-4 w-4" />
					<Icon icon={faUser} className="h-4 w-4" />
					<span className="relative">
						<Icon icon={faCartShopping} className="h-4 w-4" />
						<span
							className="absolute -end-1.5 -top-1.5 grid h-3 w-3 place-items-center rounded-full text-[7px] font-bold text-white"
							style={{ background: "var(--brand-1)" }}
						>
							2
						</span>
					</span>
				</div>
			</div>

			{/* Banner skeleton */}
			<div className="mx-5 overflow-hidden rounded-xl">
				<div className="jana-shimmer flex min-h-38 flex-col justify-center gap-2.5 p-6">
					<div className="h-3 w-3/5 rounded-full bg-white/50" />
					<div className="h-3 w-2/5 rounded-full bg-white/35" />
					<div className="mt-3 h-7 w-28 rounded-md" style={{ background: "#1c1c1c" }} />
				</div>
			</div>

			{/* Pagination dots */}
			<div className="flex items-center justify-center gap-1.5 py-3">
				{[0, 1, 2].map((i) => (
					<span key={i} className="jana-dot" style={{ animationDelay: `${i}s` }} />
				))}
			</div>

			{/* Featured products */}
			<div className="flex items-center justify-between px-5 pb-2.5">
				<span className="text-[11px] font-semibold text-[#1c1c1c]">{t.featured}</span>
				<span
					className="flex items-center gap-1 text-[11px] font-semibold"
					style={{ color: "var(--brand-1)" }}
				>
					{t.viewAll}
					<Icon icon={faChevronRight} className="h-3 w-3" />
				</span>
			</div>

			<div className="grid grid-cols-4 gap-2 px-5 pb-5">
				{[0, 1, 2, 3].map((i) => (
					<div key={i}>
						<PlaceholderCard
							className="aspect-square rounded-lg"
							style={{ animationDelay: `${i * 0.2}s` }}
						/>
						<div className="mt-1.5 h-2 w-4/5 rounded-full bg-[#e5e7eb]" />
					</div>
				))}
			</div>
		</div>
	);
}

export default HeroStorePlaceholder;
